module.exports = __webpack_public_path__ + "static/media/lock.2fc06d1a.svg";